var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('section',{staticClass:"main-content"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Recent Jobs")]),_vm._v(" "),_c('job-table')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }